import useMountEffect from "core/hooks/useMountEffect";
import { useAuth } from "react-oidc-context";
import { logoutChannel } from "modules/auth/channels";

const Authenticated = ({ children }) => {
  const {
    isAuthenticated,
    isLoading,
    error,
    querySessionStatus,
    signinRedirect,
  } = useAuth();

  useMountEffect(() => {
    const handleLogoutMessage = (event) => {
      querySessionStatus()
        .then((status) => console.log("querySessionStatus.success", { status }))
        .catch((error) => {
          console.info("querySessionStatus.error", { error });

          if (error.message === "login_required") {
            signinRedirect();
          }
        });
    };
    logoutChannel.addEventListener("message", handleLogoutMessage);
    return () =>
      logoutChannel.removeEventListener("message", handleLogoutMessage);
  });

  if (isAuthenticated && !isLoading && !error) {
    return children;
  }

  return null;
};

export default Authenticated;
